import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ index, eyebrow, title, testId }) {
  return (
    <Reveal className="mb-5">
      <div className="flex items-baseline gap-3">
        <span className="font-display text-sm tracking-[0.3em] text-[#1663E6]/70">{index}</span>
        <span className="text-xs tracking-[0.3em] text-slate-400 uppercase">{eyebrow}</span>
      </div>
      <h2
        data-testid={testId}
        className="mt-3 text-2xl font-bold tracking-tight text-[#0F1E3D] sm:text-3xl"
      >
        {title}
      </h2>
      <div className="mt-4 h-0.5 w-14 rounded-full bg-[linear-gradient(90deg,#1663E3,transparent)]" />
    </Reveal>
  );
}
